import { InsuranceProcessStatusEnum } from '../../../../core/models/enums'
import HealthInsuranceProcessStepEnum from '@/modules/health/hiring/models/APP/HealthInsuranceProcessStepEnum'
import DentalInsuranceProcessStepEnum from '@/modules/dental/hiring/models/APP/DentalInsuranceProcessStepEnum'
import type PetsInsuranceProcessStepEnum from '@/modules/pets/hiring/models/APP/PetsInsuranceProcessStepEnum'
import type TravelInsuranceProcessStepEnum from '@/modules/travel/hiring/models/APP/TravelInsuranceProcessStepEnum'
import type LifeInsuranceProcessStepEnum from '@/modules/life/hiring/models/APP/LifeInsuranceProcessStepEnum'
import type ForeignHealthInsuranceProcessStepEnum from '@/modules/foreign-health/hiring/models/APP/ForeignHealthInsuranceProcessStepEnum'

type InsuranceProcessStepType =
  | HealthInsuranceProcessStepEnum
  | DentalInsuranceProcessStepEnum
  | PetsInsuranceProcessStepEnum
  | TravelInsuranceProcessStepEnum
  | LifeInsuranceProcessStepEnum
  | ForeignHealthInsuranceProcessStepEnum

const FIRST_STATUS = InsuranceProcessStatusEnum.IN_PROCESS
const FIRST_STEP = HealthInsuranceProcessStepEnum.RATER

export default class ProcessStatus {
  statusCode: InsuranceProcessStatusEnum | null
  stepCode: InsuranceProcessStepType | null

  constructor(data: Partial<ProcessStatus> = {}) {
    this.statusCode = data.statusCode ?? FIRST_STATUS
    this.stepCode = data.stepCode ?? FIRST_STEP
  }

  updateAttributes(newAttributes: Partial<ProcessStatus>) {
    Object.assign(this, newAttributes)
  }
}
